import { render, staticRenderFns } from "./S3StorageInstructions.vue?vue&type=template&id=52db27c8&"
import script from "./S3StorageInstructions.vue?vue&type=script&lang=ts&"
export * from "./S3StorageInstructions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports